import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-amber-950 text-amber-100" data-id="element-92" data-mp="3gfsmscqd8umz">
      <div className="h-1.5 w-full bg-amber-500" aria-hidden="true" data-id="element-93" data-mp="3ggk90wy2pg0l" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-94" data-mp="32ovvcp86ejhi">
        <p className="text-lg font-extrabold uppercase text-stone-50" data-id="element-95" data-mp="36p6d0z5byyc7">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-96" data-mp="3uf0mr7ucs6s8">Created by Oil &amp; Gas education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-amber-100/20 pt-6 text-xs" data-id="element-97" data-mp="38h81hlebwon">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}